import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "2192",
  height: "1491",
  viewBox: "0 0 2192 1491",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2191.5 1489.5L3 931L1385 1",
      stroke: "url(#paint0_linear_11_472)",
      "stroke-opacity": "0.32",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "paint0_linear_11_472",
        x1: "2113.74",
        y1: "2507.65",
        x2: "-1034.44",
        y2: "-614.429",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", {
          "stop-color": "#001A78",
          "stop-opacity": "0"
        }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#596294"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }